// FormField — wraps a label + control + optional help/error.
// The control passes through children unchanged so any input
// component (Input, Select, Textarea, etc.) can be wrapped.

import FormError from './FormError'

export default function FormField({
  label,
  htmlFor,
  required = false,
  help,
  error,
  children,
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%' }}>
      {label && (
        <label
          htmlFor={htmlFor}
          style={{
            fontSize: 9,
            color: 'var(--olv-text-tertiary)',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            fontFamily: 'var(--font-mono)',
          }}
        >
          {label}
          {required && <span style={{ color: 'var(--olv-purple)', marginLeft: 4 }}>*</span>}
        </label>
      )}
      {children}
      {help && !error && (
        <span style={{
          fontSize: 11,
          color: 'var(--olv-text-tertiary)',
          fontFamily: 'var(--font-body)',
        }}>
          {help}
        </span>
      )}
      {error && <FormError>{error}</FormError>}
    </div>
  )
}
